export const profileSelection = {
    fullName: {
        selectable: false,
        selected: true,
        name: "Full name",
        type: "string",
    },
    occupation: {
        selectable: true,
        selected: true,
        name: "Occupation",
        type: "string",
    },
    completedProjectCount: {
        selectable: true,
        selected: true,
        name: "Completed projects count",
        type: "string",
    },
    onboardedClientsCount: {
        selectable: true,
        selected: true,
        name: "Onboarded clients count",
        type: "string",
    },
    bio: {
        selectable: true,
        selected: true,
        name: "Bio",
        type: "string",
    },
    location: {
        selectable: true,
        selected: true,
        name: "Location",
        type: "string",
    },
    contactInformation: {
        name: "Contact information",
        type: "object",
        children: {
            email: {
                selectable: true,
                selected: true,
                type: "string",
                name: "Email",
            },
            phoneNumber: {
                selectable: true,
                selected: true,
                type: "string",
                name: "Phone number",
            },
        },
    },
    portfolio: {
        type: "object",
        name: "Portfolio",
        children: {
            socials: {
                selectable: true,
                selected: true,
                name: "Social Links",
                type: "string",
            },
            skills: {
                selectable: true,
                selected: true,
                type: "string",
                name: "Skills",
                type: "string",
            },
            links: {
                selectable: true,
                selected: true,
                type: "string",
                name: "links",
                type: "string",
            },
        },
    },
};